import { Injectable, InjectionToken } from '@angular/core';
import { ExtensionsNoopService as ZacExtensionsNoopService } from 'ziti-console-lib';
import { FeatureService } from './feature.service';
export const SHAREDZ_EXTENSION = new InjectionToken<any>('SHAREDZ_EXTENSION');

export interface ExtensionService {
    extendAfterViewInits(extentionPoints: any): void;
}

@Injectable({
    providedIn: 'root',
})
export class ExtensionsNoopService extends ZacExtensionsNoopService {
    
    useDeleteSplitButton = true;

    constructor(private featureService: FeatureService) {
        super();
    }

    get showApiCalls(): boolean {
        return this.featureService.powerUserEnabled;
    }
}
